import { absolutePath } from "./absolutePath";

interface EventsFnProps {
  params?: Record<string, unknown>;
  slug?: string;
  spaceId?: string | number;
}

export const events = {
  accessGroups: {
    index: ({ params = {} }: { params?: Record<string, unknown> } = {}) =>
      absolutePath("events/access_groups", params),
  },
  create: ({ spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events`, params),
  update: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}`, params),
  destroy: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}`, params),
  show: ({ spaceId, slug, params = {} }: EventsFnProps) =>
    absolutePath(`spaces/${spaceId}/events/${slug}`, params),
  attendees: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/event_attendees`, params),
  pin: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/pin`, params),
  duplicate: ({ spaceId, slug, params }: EventsFnProps) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/duplicate`, params),
  allEvents: ({ params }: EventsFnProps) =>
    absolutePath(`events/community_events`, params),
  allEventsTopics: ({ params = {} }: EventsFnProps) =>
    absolutePath(`events/topics`, params),
  addToCalendar: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/add_to_calendar`, params),
  downloadCalendar: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/download_calendar`, params),
  calculateSchedule: ({ slug, spaceId, params = {} }: EventsFnProps = {}) =>
    absolutePath(`spaces/${spaceId}/events/${slug}/calculate_schedule`, params),
};
